"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsUpgrade = void 0;
const utilsSQLite_1 = require("./utilsSQLite");
class UtilsUpgrade {
    constructor() {
        this.sqliteUtil = new utilsSQLite_1.UtilsSQLite();
    }
    /**
     * OnUpgrade
     * @param mDB
     * @param vUpgDict
     * @param dbName
     * @param curVersion
     * @param targetVersion
     */
    async onUpgrade(mDB, vUpgDict, curVersion, targetVersion) {
        let changes;
        const sortedKeys = Object.keys(vUpgDict)
            .map(item => parseInt(item))
            .sort();
        for (const versionKey of sortedKeys) {
            if (versionKey > curVersion && versionKey <= targetVersion) {
                const statements = vUpgDict[versionKey].statements;
                if (statements.length === 0) {
                    return Promise.reject('onUpgrade: statements not given');
                }
                try {
                    // set Foreign Keys Off
                    await this.sqliteUtil.setForeignKeyConstraintsEnabled(mDB, false);
                    const initChanges = await this.sqliteUtil.dbChanges(mDB);
                    await this.executeStatementsProcess(mDB, statements);
                    await this.sqliteUtil.setVersion(mDB, versionKey);
                    // set Foreign Keys On
                    await this.sqliteUtil.setForeignKeyConstraintsEnabled(mDB, true);
                    changes = (await this.sqliteUtil.dbChanges(mDB)) - initChanges;
                }
                catch (err) {
                    return Promise.reject(`onUpgrade: ${err}`);
                }
            }
        }
        return Promise.resolve(changes);
    }
    /**
     * ExecuteStatementProcess
     * @param mDB
     * @param statements
     */
    async executeStatementsProcess(mDB, statements) {
        try {
            await this.sqliteUtil.beginTransaction(mDB, true);
            for (const statement of statements) {
                await this.sqliteUtil.execute(mDB, statement, false);
            }
            await this.sqliteUtil.commitTransaction(mDB, true);
            return Promise.resolve();
        }
        catch (err) {
            await this.sqliteUtil.rollbackTransaction(mDB, true);
            return Promise.reject(`ExecuteStatementProcess: ${err}`);
        }
    }
}
exports.UtilsUpgrade = UtilsUpgrade;
//# sourceMappingURL=utilsUpgrade.js.map